/**
 * Scheduling Constants
 * 
 * Shared constants for the scheduling system.
 * Used by both admin and parent-facing components.
 */

// Slot type colors - Dark theme optimized for visibility
export const SLOT_COLORS: Record<string, { bg: string; border: string; text: string }> = {
  lesson: { bg: 'rgba(10, 132, 255, 0.2)', border: '#5C2D91', text: '#FFFFFF' },
  assessment: { bg: 'rgba(191, 90, 242, 0.2)', border: '#BF5AF2', text: '#FFFFFF' },
  consultation: { bg: 'rgba(48, 209, 88, 0.2)', border: '#34C759', text: '#FFFFFF' },
  catch_up: { bg: 'rgba(255, 159, 10, 0.2)', border: '#FF9500', text: '#FFFFFF' },
  review: { bg: 'rgba(100, 210, 255, 0.2)', border: '#64D2FF', text: '#FFFFFF' },
};

// Slot type display labels
export const SLOT_TYPE_LABELS: Record<string, string> = {
  assessment: 'Assessment',
  lesson: 'Lesson',
  catch_up: 'Catch-up',
  review: 'Review',
  consultation: 'Consultation',
};

// Minimum slot spacing: slots start at :00 or :30 boundaries for short lessons
// For longer lessons (>30 min), spacing equals duration to prevent overlap
export const MIN_SLOT_SPACING_MINUTES = 30;

// Default slot duration in minutes
export const DEFAULT_SLOT_DURATION = 25;

// Business hours for parent calendar (wider than admin)
export const PARENT_BUSINESS_HOURS = {
  start: '07:00',
  end: '21:00',
};

// Business hours for admin calendar
export const ADMIN_BUSINESS_HOURS = {
  start: '08:00',
  end: '18:00',
  daysOfWeek: [1, 2, 3, 4, 5], // Monday - Friday
};

// Cancellation policy
export const CANCELLATION_NOTICE_HOURS = 24;

/**
 * Calculate actual spacing: max of minimum spacing or duration
 * Prevents overlapping slots for longer durations
 */
export const getSlotSpacing = (durationMinutes: number): number => {
  return Math.max(MIN_SLOT_SPACING_MINUTES, durationMinutes);
};

/**
 * Get color for a slot type
 */
export const getSlotColor = (slotType: string) => {
  return SLOT_COLORS[slotType] || SLOT_COLORS.lesson;
};

/**
 * Get display label for a slot type
 */
export const getSlotTypeLabel = (slotType: string) => {
  return SLOT_TYPE_LABELS[slotType] || slotType;
};
